// extracted by mini-css-extract-plugin
export var link = "_uc-0";